/**
 * Global Paddle.js initialization for Retain integration.
 *
 * Paddle Retain requires Paddle.Initialize() on every page load —
 * not just inside the checkout component. This is called from main.tsx
 * so Retain validation passes on public-facing pages (homepage, pricing).
 *
 * The checkout component re-initializes with event callbacks when opened.
 */
export function initPaddleGlobal(): void {
  const token = import.meta.env.VITE_PADDLE_CLIENT_TOKEN as string | undefined;
  const environment = import.meta.env.VITE_PADDLE_ENVIRONMENT as string | undefined;

  if (!token || !window.Paddle) return;

  try {
    if (environment === "sandbox") {
      window.Paddle.Environment.set("sandbox");
    }

    window.Paddle.Initialize({
      token,
      pwCustomer: {} as any,
    });
  } catch {
    // Non-blocking — Retain is nice-to-have, checkout still works via component init
  }
}
